import React, { useState } from "react";
import "../styles/card.css";

const Card = ({alt, src, name, price, hoverColor, hoverTextColor }) => {
  const [isMouseOver, setMouseOver] = useState(false);

  const handleMouseOver = () => {
    setMouseOver(true);
  };

  const handleMouseLeave = () => {
    setMouseOver(false);
  };

  const getBackgroundColor = () => {
    if (isMouseOver) return hoverColor;
    return "";
  };

  const getTextColor = () => {
    if (isMouseOver) return hoverTextColor;
    return "";
  };

  const getRotate = () => {
    if (isMouseOver) return "rotate(30deg)";
    return "";
  };

  return (
    <>
      <div
        className="card"
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        style={{ backgroundColor: getBackgroundColor(), color: getTextColor() }}
      >
        <img className="image" src={src} alt={alt} style={{ transform: getRotate() }}/>
        <div className="image"></div>
        <p className="name-price">
          <span className="name">{name}</span> <br />
          <span className="price" style={{ color: getTextColor() }}>{price}</span>
        </p>
      </div>
    </>
  );
}

export default Card;